// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607150812/js/" + chunkId + "." + {"44":"29fb422b","225":"3e5257cc","481":"2bb1c333","486":"301bc485","770":"cd24f68e"}[chunkId] + ".0.29124664715497073.chunk.js";
};